<script setup lang="ts">
import ObjectField from "@/generated-report/components/form-schema/fields/ObjectField.vue";
import {ArraySchema, ArrayValue, ObjectSchema, ObjectValue, Schema, SchemaValue} from "@/generated-report/interfaces";
import ArrayField from "@/generated-report/components/form-schema/fields/ArrayField.vue";
import StringField from "@/generated-report/components/form-schema/fields/StringField.vue";

defineProps<{
    schema: Schema;
    nestingLevel?: number;
}>();

const value = defineModel<SchemaValue | undefined>({required: true});
</script>

<template>
  <div>
    <ObjectField
      v-if="schema.type === 'object'"
      v-model="value as ObjectValue"
      :schema="schema as ObjectSchema"
      :nesting-level="nestingLevel"
    />
    <ArrayField
      v-else-if="schema.type === 'array'"
      v-model="value as ArrayValue"
      :schema="schema as ArraySchema"
      :nesting-level="nestingLevel"
    />
    <StringField
      v-else-if="schema.type === 'string'"
      v-model="value as string"
      :schema="schema"
      :nesting-level="nestingLevel"
    />
    <div v-else>
      Type de champ non pris en charge
    </div>
  </div>
</template>

<style scoped>

</style>
